/**
 * Collection Links Component
 * Handles smooth scrolling and enhanced interactions for collection links
 */

class CollectionLinks extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.setupImageLoading();
  }

  setupImageLoading() {
    const images = this.querySelectorAll('.collection_tab_img img');
    
    images.forEach(img => {
      if (img.complete) {
        img.style.opacity = '1';
      } else {
        img.addEventListener('load', () => {
          img.style.opacity = '1';
        });
        
        img.addEventListener('error', () => {
          // Hide broken images gracefully
          img.style.display = 'none';
        });
      }
    });
  }
}

// Register the custom element
if (!customElements.get('collection-links')) {
  customElements.define('collection-links', CollectionLinks);
}

// Initialize for existing elements
document.addEventListener('DOMContentLoaded', () => {
  const collectionLinksElements = document.querySelectorAll('.collection-links-wrapper');
  collectionLinksElements.forEach(element => {
    if (!element.closest('collection-links')) {
      const wrapper = document.createElement('collection-links');
      element.parentNode.insertBefore(wrapper, element);
      wrapper.appendChild(element);
    }
  });
});
